// import { Base64 } from 'js-base64'

export default {
  methods: {
    getImg (preset, imgPath) {
      // if (imgPath.substr(0, 1) === '/') {
      //   imgPath = imgPath.substr(1)
      // }

      // const targetPath = Base64.encode(imgPath)
      return imgPath
      // return `${process.env.VUE_APP_IMG_BASE_URI}/_/${preset}/${targetPath}`
    }
  }
}
